import { lazy } from 'react';

export { Edit, Create } from './form';
export { ListPage as List } from './list';
export { DetailsPage as Details } from './details';

export const Questionnaire = lazy(() => import('./questionnaire'));
